import React, { useRef, useState, useEffect } from 'react';
import { useInView } from '../hooks';

const STATS = [
  { end: 200, suffix: '+', label: 'Happy Clients' },
  { end: 500, suffix: '+', label: 'Properties Cleaned' },
  { end: 3000, suffix: '+', label: 'Hours of Cleaning' },
  { end: 5, suffix: '★', label: 'Average Rating' },
];

function AnimatedCount({ end, suffix, active }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const duration = 1600;
    const step = 16;
    const increment = end / (duration / step);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) { setCount(end); clearInterval(timer); }
      else setCount(Math.floor(start));
    }, step);
    return () => clearInterval(timer);
  }, [active, end]);

  return <>{count.toLocaleString()}{suffix}</>;
}

export default function StatsBar() {
  const ref = useRef(null);
  const inView = useInView(ref, 0.3);

  return (
    <div ref={ref} style={{
      background: 'var(--navy)', padding: '50px 5%',
      display: 'flex', justifyContent: 'center', flexWrap: 'wrap',
    }}>
      {STATS.map(({ end, suffix, label }, i) => (
        <div key={label} style={{
          flex: 1, minWidth: 140, textAlign: 'center',
          padding: '20px 30px',
          borderRight: i < STATS.length - 1 ? '1px solid rgba(255,255,255,0.1)' : 'none',
        }}>
          <strong style={{
            display: 'block',
            fontFamily: "'Playfair Display', serif",
            fontSize: '2.4rem', color: 'var(--orange)',
            lineHeight: 1, marginBottom: 6,
          }}>
            <AnimatedCount end={end} suffix={suffix} active={inView} />
          </strong>
          <span style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.5px' }}>{label}</span>
        </div>
      ))}
    </div>
  );
}
